import { format } from "date-fns";
import IUserHistoryFilter from "interfaces/IUserHistoryFilter";

const initialUserHistoryFilter = () : IUserHistoryFilter => ({
  actions: [],
  sites: [],
  logDate: undefined,
  searchText: ""
});

export { initialUserHistoryFilter };
